
import { onceOptions } from "./onceOptions";

type ReadyCallback = () => void;


export const ready = (callback: ReadyCallback, debugMessage?: string) => {

  if (document.readyState !== "loading") {
    window.requestAnimationFrame(callback);
    if (debugMessage) {
      console.log(debugMessage, "requestAnimationFrame");
    }
  } else {
    document.addEventListener("DOMContentLoaded", callback);
    if (debugMessage) {
      console.log(debugMessage, "DOMContentLoaded");
    }
  }

}
